import { formatProduct, formatLastActivityTime, formatPriceWithPrecision } from "./utilfunction";

// Helper function to format price for order details display
const formatOrderDetailPrice = (price, exchange, pricePrecision) => {
  if (!price && price !== 0) return 'N/A';
  
  if ((exchange === 'CDS' || exchange === 'DCSX') && pricePrecision !== undefined) {
    const formattedPrice = formatPriceWithPrecision(price, pricePrecision, {
      showCurrency: false,
      showCommas: false,
      removeTrailingZeros: false
    });
    return `₹ ${formattedPrice}`;
  }
  
  // Default formatting for non-CDS/DCSX exchanges
  return `₹ ${price.toLocaleString('en-IN', { minimumFractionDigits: 2 })}`;
};

export const getOrderDetailFields = (order, formatTime, type = 'PENDING') => {
  const baseFields = [
    { label: 'Order ID', value: order.oms_order_id },
    { label: 'Order Type', value: order.order_type },
    { label: 'Product', value: formatProduct(order.product) },
    { label: 'Exchange Order ID', value: order.exchange_order_id },
  ];

  switch (type) {
    case 'PENDING':
      return [
        ...baseFields,
        {
          label: 'Price',
          value: formatOrderDetailPrice(order.price, order.exchange, order.price_precision),
        },
        
        { label: 'Tr. Price', value: order.trigger_price ? formatOrderDetailPrice(order.trigger_price, order.exchange, order.price_precision) : 'N/A' },
        { label: 'Avg. Price', value: order.average_price ? formatOrderDetailPrice(order.average_price, order.exchange, order.price_precision) : 'N/A' },
        { label: 'Disc. Qty', value: order.disclosed_quantity },
        { label: 'Client ID', value: order.client_id },
        {
          label: 'Order Update Time',
          value: formatLastActivityTime(order.last_activity_reference),
        },
        { label: 'Order Entry Time', value: formatTime(order.order_entry_time) },
        { label: 'Status', value: order.order_status },
      ];

    case 'COMPLETED':
      return [
        ...baseFields,
        {
          label: 'Order Price',
          value: formatOrderDetailPrice(order.price, order.exchange, order.price_precision),
        },
        { label: 'Tr. Price', value: order.trigger_price ? formatOrderDetailPrice(order.trigger_price, order.exchange, order.price_precision) : 'N/A' },
        { label: 'Avg. Price', value: order.average_price ? formatOrderDetailPrice(order.average_price, order.exchange, order.price_precision) : 'N/A' },
        { label: 'Disc. Qty', value: order.disclosed_quantity },
        { label: 'Client ID', value: order.client_id },
        {
          label: 'Order Update Time',
          value: formatLastActivityTime(order.last_activity_reference),
        },
        { label: 'Order Entry Time', value: formatTime(order.order_entry_time) },
        { label: 'Status', value: order.order_status },
      ];

    case 'TRADE':
      return [
        ...baseFields,
        {
          label: 'Price',
          value: formatOrderDetailPrice(order.trade_price, order.exchange, order.price_precision),
        },
        { label: 'Order Entry Time', value: formatTime(order.order_entry_time) },
      ];

    default:
      return baseFields;
  }
}; 